import { getToken } from '@/helpers/auth';
import { useQuery } from '@tanstack/react-query';

import { getLangCountry } from '@/helpers/languages';
import { fetchCountries } from '@/fetchers/mapping';
import { useRouter } from 'next/router';

export function useCountries() {
  const token = getToken();
  const router = useRouter();

  return useQuery(['countries'], async () => {
    return fetchCountries({
      token,
      ...getLangCountry(router.query)
    });
  });
}
